import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './place.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PlaceDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const placeEntity = useAppSelector(state => state.place.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="placeDetailsHeading">
          <Translate contentKey="fleetSenseApp.place.detail.title">Place</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{placeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.place.name">Name</Translate>
            </span>
          </dt>
          <dd>{placeEntity.name}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.place.type">Type</Translate>
            </span>
          </dt>
          <dd>{placeEntity.type}</dd>
          <dt>
            <span id="placeId">
              <Translate contentKey="fleetSenseApp.place.placeId">Place Id</Translate>
            </span>
          </dt>
          <dd>{placeEntity.placeId}</dd>
          <dt>
            <span id="latitude">
              <Translate contentKey="fleetSenseApp.place.latitude">Latitude</Translate>
            </span>
          </dt>
          <dd>{placeEntity.latitude}</dd>
          <dt>
            <span id="longitude">
              <Translate contentKey="fleetSenseApp.place.longitude">Longitude</Translate>
            </span>
          </dt>
          <dd>{placeEntity.longitude}</dd>
          <dt>
            <span id="approved">
              <Translate contentKey="fleetSenseApp.place.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{placeEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.place.company">Company</Translate>
          </dt>
          <dd>{placeEntity.company ? placeEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/place" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/place/${placeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PlaceDetail;
